<template>
  <div class="machine-group">
    <Insert :type="insertType" :show="insertShow" :rowData="rowData" @refresh="handlerRefresh" @close="insertClose" />
    <ApplicationMer :info="rowData" :show="showAppMer" @refresh="handlerRefreshAppMer" @close="handlerCloseAppMer" />
    <div class="el-search vue-top-padding radius">
      <el-left>
        <el-button @click="handlerAdd" type="primary" size="small" icon="el-icon-plus">{{ $t('sales-plan.index.9398864-0') }}</el-button>
      </el-left>
      <div class="el-right">
        <el-form
          :model="search"
          :inline="true"
          label-width="10px"
          size="small"
          class="demo-form-inline el-input-height"
        >
          <el-form-item prop="username" style="margin-bottom: 0">
            <el-date-picker
              v-model="searchDate"
              type="daterange"
              :format="'yyyy-MM-dd'"
              :value-format="'yyyy-MM-dd'"
              :range-separator="$t('sales-plan.index.9398864-1')"
              :start-placeholder="$t('sales-plan.index.9398864-2')"
              :end-placeholder="$t('sales-plan.index.9398864-3')"
              @change="handlerSearchDateChange"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="username" style="margin-bottom: 0">
            <el-input clearable v-model="search.username" :placeholder="$t('sales-plan.index.9398864-4')"></el-input>
          </el-form-item>
          <el-form-item prop="machineNo" style="margin-bottom: 0">
            <el-input clearable v-model="search.machineNo" :placeholder="$t('sales-plan.index.9398864-5')"></el-input>
          </el-form-item>
          <el-form-item prop="name" style="margin-bottom: 0">
            <el-input clearable v-model="search.name" :placeholder="$t('sales-plan.index.9398864-6')"></el-input>
          </el-form-item>
          <el-form-item style="margin: 0">
            <el-button type="primary" @click="onSubmit" icon="el-icon-search">{{ $t("common.search") }}</el-button>
            <el-button @click="resetSearch()" icon="el-icon-refresh">{{ $t("common.reset") }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="vue-padding">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="tableList"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column
          prop="username"
          :show-overflow-tooltip="true"
          :label="$t('sales-plan.index.9398864-4')"
          width="260px"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="name"
          :show-overflow-tooltip="true"
          :label="$t('sales-plan.index.9398864-6')"
          width="260px"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="name" :show-overflow-tooltip="true" :label="$t('sales-plan.index.9398864-7')" width="240px" :align="'center'">
          <template #default="scope">
            {{ scope.row.activePeriod?.startDate }} ~
            {{ scope.row.activePeriod?.endDate }}
          </template>
        </el-table-column>
        <el-table-column
          prop="machineTotalNum"
          :show-overflow-tooltip="true"
          :label="$t('sales-plan.index.9398864-8')"
          :align="'center'"
        ></el-table-column>
        <el-table-column :label="$t('sales-plan.index.9398864-9')" :align="'center'" fixed="right" width="300px">
          <template #default="scope">
            <el-button style="margin: 3px" size="mini" icon="el-icon-setting" @click="handlerMer(scope.row)">{{
              $t('sales-plan.index.9398864-10')
            }}</el-button>
            <el-button style="margin: 3px" size="mini" icon="el-icon-edit" @click="handlerEdit(scope.row)">{{
              $t('sales-plan.index.9398864-11')
            }}</el-button>
            <el-button
              style="margin: 3px"
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="delProductType(scope.row)"
              >{{ $t('sales-plan.index.9398864-12') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="tableList.length > 0"
        background
        layout="prev, pager, next"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import Insert from "./components/Insert.vue";
  import ApplicationMer from "./components/ApplicationMer.vue";
  export default {
    components: {
      Insert,
      ApplicationMer
    },
    data() {
      return {
        search: {},
        loading: false,
        tableList: [],
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        // insert
        insertShow: false,
        insertType: 1, //1 insert 2 edit
        rowData: {},
        //mer
        showAppMer: false,
        searchDate: null
      };
    },

    async mounted() {
      this.currentChange();
    },
    methods: {
      handlerSearchDateChange(e) {
        console.log(e);
        if (e) {
          this.search.startDate = e[0];
          this.search.endDate = e[1];
        } else {
          delete this.search.startDate;
          delete this.search.endDate;
        }
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.SalesPlan.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.tableList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      // 搜索
      onSubmit() {
        this.currentChange();
      },
      // 重置搜索
      resetSearch() {
        this.searchDate = null;
        Object.keys(this.search).map(key => (this.search[key] = null));
        this.currentChange();
      },
      delProductType(row) {
        this.$confirm(this.$t("invoice.index.852496-9"), this.$t("user.MachineMac.733577-6"), {
          confirmButtonText: this.$t("user.MachineMac.733577-7"),
          cancelButtonText: this.$t("user.MachineMac.733577-8"),
          type: "warning"
        })
          .then(() => {
            this.loading = true;
            this.$api
              .request(this.$url.SalesPlan.delete, this.$method.delete, {
                id: row.id
              })
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t("user.MachineMac.733577-9"));
                  this.currentChange();
                } else {
                  this.$message.error(res.msg);
                }
                this.loading = false;
              })
              .catch(err => {
                this.loading = false;
                this.$message.error(err);
              });
          })
          .catch(err => {
            console.log(err);
          });
      },
      //添加
      handlerAdd() {
        this.insertType = 1;
        this.insertShow = true;
      },
      insertClose() {
        this.insertShow = false;
      },
      handlerRefresh() {
        this.insertShow = false;
        this.currentChange();
      },
      //编辑按钮
      handlerEdit(row) {
        this.rowData = row;
        console.log(this.$t("invoice.index.852496-10"), row);
        this.insertType = 2;
        this.insertShow = true;
      },
      //mer
      handlerMer(row) {
        this.rowData = row;
        this.showAppMer = true;
      },
      handlerRefreshAppMer() {
        this.showAppMer = false;
        this.currentChange();
      },
      handlerCloseAppMer() {
        this.showAppMer = false;
      }
    }
  };
</script>
